function MetricCard({
  title,
  value,
  description,
  icon,
  variant = 'default'
}) {
  return (
    <div
      style={{
        ...styles.card,
        ...(variant === 'danger' ? styles.danger : {}),
        ...(variant === 'warning' ? styles.warning : {}),
        ...(variant === 'success' ? styles.success : {})
      }}
    >
      <div style={styles.top}>
        <div style={styles.iconBox}>{icon}</div>
        <div style={styles.statusDot} />
      </div>

      <h2 style={styles.value}>{value}</h2>
      <h3 style={styles.title}>{title}</h3>
      <p style={styles.description}>{description}</p>
    </div>
  );
}

const styles = {
  card: {
    background: 'rgba(255,255,255,0.94)',
    borderRadius: '18px',
    padding: '18px',
    boxShadow: '0 10px 24px rgba(0,0,0,0.12)',
    border: '1px solid rgba(255,255,255,0.16)',
    minHeight: '124px'
  },

  danger: {
    background:
      'linear-gradient(135deg,#7f1d1d 0%,#b91c1c 100%)',
    color: 'white'
  },

  warning: {
    background:
      'linear-gradient(135deg,#92400e 0%,#d97706 100%)',
    color: 'white'
  },

  success: {
    background:
      'linear-gradient(135deg,#065f46 0%,#0f8f6f 100%)',
    color: 'white'
  },

  top: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '11px'
  },

  iconBox: {
    width: '34px',
    height: '34px',
    borderRadius: '12px',
    background: 'rgba(255,255,255,0.12)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px'
  },

  statusDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: '#1fa97a',
    boxShadow: '0 0 10px rgba(31,169,122,0.55)'
  },

  value: {
    fontSize: '32px',
    margin: 0,
    lineHeight: '1',
    fontWeight: '850'
  },

  title: {
    margin: '9px 0 5px',
    fontSize: '14px',
    fontWeight: '850',
    lineHeight: '1.18'
  },

  description: {
    margin: 0,
    fontSize: '12px',
    lineHeight: '1.35',
    opacity: 0.76
  }
};

export default MetricCard;